import React, { Component } from 'react';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Tooltip, Select, Modal, message } from 'antd';

import { findCategory } from '../../utils/Utils';

import NewProductButton from './NewProductButton';

const Option = Select.Option;
const confirm = Modal.confirm;

class Products extends Component {

  constructor(props) {
    super(props);

    this.state = {
      filteredProducts: [],
      keyword: '',
      selectedCategoryId: 'all'
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.products) {
      // empty state
      const filteredProducts = filterProducts(nextProps.products, prevState.selectedCategoryId, prevState.keyword);
      return { filteredProducts: filteredProducts }
    }
    return null;
  }

  onProductTypeClick(type) {
    console.log(type);
  }

  onCategoryDropdownClick(categoryId) {
    const filteredProducts = filterProducts(this.props.products, categoryId, this.state.keyword);
    this.setState({
      filteredProducts: filteredProducts,
      selectedCategoryId: categoryId
    });
  }

  onSearchTextChange(searchField) {

    const text = searchField.target.value;
    const filteredProducts = filterProducts(this.props.products, this.state.selectedCategoryId, text);
    this.setState({
      filteredProducts: filteredProducts,
      keyword: text
    });
  }

  onDeleteClick(product) {

    confirm({
      title: 'Are you sure you want to delete this product?',
      content: `"${product.name_en}"`,
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: () => {
        console.log('OK');

        // perform delete
        const hideLoading = message.loading('Deleting Product...', 0);

        this.props.deleteProduct(product.id, (error) => {
          hideLoading();

          if (error) {
            message.error('Error Deleting Product', 2.5);
          } else {
            message.success('Product Deleted', 2.5);
          }
        });
      }
    });
  }

  renderCategoryDropdown() {
    const { categories } = this.props;

    if (!categories) {
      return;
    }

    let options = [<Option key={'all'} value={'all'}>{'All'}</Option>];

    const catOptions = categories.map(category => {
      return (
        <Option key={category.id} value={category.id}>{category.name_en}</Option>
      );
    });

    options.push(...catOptions);

    return (
      <Select
        className="dropdown category"
        defaultValue="all"
        onChange={this.onCategoryDropdownClick.bind(this)}
        placeholder="All"
        style={{
          height: 40,
          backgroundColor: '#FAFAFA',
          border: '1px solid #E9EAEA',
          borderRadius: 50,
          width: 240

        }}
      >
        {options}
      </Select>
    );
  }

  renderProductTypesDropdown() {
    return (
      <div className="dropdown sort-dropdown type">
        <button
          className="btn dropdown-toggle sort-list type-list"
          type="button"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          All Types
                </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li>
            <a className="dropdown-item" onClick={() => this.onProductTypeClick(0)}>All Types</a>
          </li>
          <li>
            <a className="dropdown-item" onClick={() => this.onProductTypeClick(1)}>Single Product</a>
          </li>
          <li>
            <a className="dropdown-item" onClick={() => this.onProductTypeClick(2)}>Product Set</a>
          </li>
        </ul>
      </div>
    );
  }

  renderActions(product) {
    return (
      <div>
        <Tooltip title="Edit">
          <Link to={`/products/${product.id}`} className="btn btn-tooltip">
            <img src="/resources/img/ic-edit.png" alt="Edit" />
          </Link>
        </Tooltip>
        <Tooltip title="Delete">
          <button className="btn btn-tooltip" onClick={() => this.onDeleteClick(product)}>
            <img src="/resources/img/ic-delete.png" alt="Delete" />
          </button>
        </Tooltip>
      </div>
    );
  }

  renderProductName(product) {
    let imagePath = '/resources/img/img-product.png';
    const productImage = _.find(product.image_paths);
    if (productImage) {
      imagePath = productImage.thumb_url;
    }
    return (
      <div>
        <img
          className="product-img"
          src={imagePath}
          alt=""
          style={{ width: 32, height: 27, marginLeft: 0, marginRight: 24, objectFit: 'contain' }}
        />
        {product.name_en}
      </div>
    );
  }

  productType(product) {
    if (typeof product.products === 'undefined') {
      return 'Single';
    }
    return 'Set';
  }

  renderCategoryName(catIds) {
    const { categories } = this.props;

    let names = '';
    catIds.map(id => {
      const result = findCategory(categories, id);
      if (result) {
        names = (names === '') ? result.name_en : `${names}, ${result.name_en}`;
      }
      return null;
    })
    return <div>{names}</div>;
  }

  renderPrice(product) {
    let numberPrice = parseFloat(product.prices.based.regular);
    if (!numberPrice) {
      numberPrice = 0.0;
    }
    return numberPrice.toLocaleString(undefined, { style: 'currency', currency: 'THB' });
  }

  renderTable() {
    const { filteredProducts } = this.state;
    // const { products, categories } = this.props;
    // const data = _.toArray(products);

    return (
      <ReactTable
        data={filteredProducts}
        columns={[
          {
            Header: 'Product',
            id: 'product',
            accessor: d => this.renderProductName(d)
          },
          {
            Header: 'Category',
            id: 'category',
            accessor: d => this.renderCategoryName(d.category_ids)
          },
          {
            Header: 'SKU',
            id: 'sku',
            // className: 'col-center',
            accessor: d => d.sku,
            width: 90
          },
          {
            Header: 'Price',
            id: 'price',
            className: 'col-right',
            headerClassName: 'col-right',
            accessor: d => this.renderPrice(d),
            width: 100
          },
          {
            Header: 'Status',
            id: 'status',
            accessor: d => this.renderStatus(d),
            width: 160
          },
          {
            Header: '',
            id: 'actionButtons',
            className: 'col-center',
            accessor: d => this.renderActions(d),
            width: 60
          }
        ]}
        defaultPageSize={10}
        className="-highlight"
      />
    );
  }

  renderStatus(product) {

    switch (product.status) {
      case 0:
        return (
          <div>
            <span className="circle green-circle"></span>
            Ready For Sale
                    </div>
        );
      case 1:
        return (
          <div>
            <span className="circle orange-circle"></span>
            Out of Stock
                    </div>
        );
      case 2:
        return (
          <div>
            <span className="circle red-circle"></span>
            Removed From Sale
                    </div>
        );
      case 3:
        return (
          <div>
            <span className="circle red-circle"></span>
            Removed
                    </div>
        );
      default:
        return (
          <div>
            <span className="circle green-circle"></span>
            Unknown
                    </div>
        );
    }
  }

  render() {
    return (
      <div>
        <div className="function product-list">
          <div className="row">
            <div className="col-md-auto">
              <div className="input-group search-box">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search..."
                  name="search-box"
                  onChange={this.onSearchTextChange.bind(this)}
                  value={this.state.keyword}
                />
              </div>
            </div>
            <div className="col-md-auto">
              {this.renderCategoryDropdown()}
            </div>
            {/* <div className="col-md-auto">
                            {this.renderProductTypesDropdown()}
                        </div> */}
            <NewProductButton />
          </div>
        </div>
        {this.renderTable()}
      </div>
    )
  }
}

function filterProducts(products, categoryId, keyword) {

  let results = [];
  if (categoryId === 'all') {
    if (keyword == null || keyword === '') {
      return _.toArray(products);
    }

    // has keyword
    results = _.filter(products, (product) => {
      return product.sku.search(new RegExp(keyword, 'i')) > -1
    });
  } else {
    results = _.filter(products, (product) => {
      const catMatch = _.includes(product.category_ids, categoryId);
      return (
        catMatch &&
        product.sku.search(new RegExp(keyword, 'i')) > -1
      );
    });
  }
  return results;
}

export default Products;


// WEBPACK FOOTER //
// ./src/views/products/Products.js